<!--
 * @Date: 2020-05-22 10:40:13
 * @LastEditTime: 2021-03-15 17:16:58
--> 
<template>
  <span class="srm-upload">
    <a-upload
      :fileList="fileList"
      :remove="handleRemove"
      :beforeUpload="beforeUpload"
      :multiple="multiple"
    >
      <a-button>
        <a-icon type="upload" />
        {{ text }}
      </a-button>
    </a-upload>
  </span>
</template>

<script>
export default {
  props: {
    param: Object,
  },
  data() {
    return {
      fileList: [],
      text: '',
      fileNum: 1,
      key: 'file',
      suffixRule: [".xls", ".xlsx"],
      size: 20,// M
      multiple: false,
      type: 'upload'
    }
  },
  mounted() {
    this.text = this.param.text || '选择文件';
    this.fileNum = this.param.fileNum || 1;
    this.key = this.param.key || 'file';
    this.suffixRule = this.param.suffixRule || [".xls", ".xlsx"];
    this.size = this.param.size || 20;
    this.multiple = this.param.multiple || false;
    this.type = this.param.type || 'upload';

    this.param.getFileList = this.getFileList;
    this.param.handleExpory = this.param.type === 'readExcel' ? this.handleExpory : undefined;
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    // 前端生成导出excel文件
    handleExpory(columns, dataSource, text) {
      const excel = new this.Excel();
      return new Promise((resolve, reject) => {
        excel
          .addSheet('test')
          .addColumns(columns)
          .addDataSource(dataSource)
          .saveAs(text + '.xlsx');
        resolve();
      });
    },
    readExcel(file, columns) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {// 异步执行
          try {
            // 以二进制流方式读取得到整份excel表格对象
            let data = e.target.result, workbook = this.XLSX.read(data, { type: 'binary' })
            const exlname = workbook.SheetNames[0] // 取第一张表
            const exl = this.XLSX.utils.sheet_to_json(workbook.Sheets[exlname]) // 生成json表格内容
            let arr = []
            
            let keys = []
            let keyMap = {}
            if (columns) columns.forEach(d => {
              const key = d.title
              keys.push(key)
              keyMap[key] = { ...d }
            });
            exl.map(d => {
              let obj = {}
              // title映射
              if (keys.length > 0) {
                keys.forEach(key => {
                  obj[keyMap[key].dataIndex] = d[key]
                })
              } else {
                obj = { ...d }
              }
              // 对获取的Excel数据进行操作
              arr.push(obj)
            })
            resolve(arr)
          } catch (e) {
            reject(e.message)
          }
        }
        reader.readAsBinaryString(file)
      });
    },
    beforeUpload(file) {
      // 文件校验
      const fileSize = file.size < this.size * 1024 * 1024;
      const extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      if (file.size > this.size * 1024 * 1024) {
        this.$message.error(`上传文件不能超过${this.size}M!`);
        return false;
      } else if (this.suffixRule.length > 0 && !this.suffixRule.includes(extName)) {
        this.$message.error(`请上传，${this.suffixRule.toString()}等格式的文件!`);
        return false;
      }

      if (this.fileNum === 1) this.fileList = [file];
      else if (this.fileList.length >= this.fileNum) {
        this.$message.error(`单次上传限制${this.fileNum}个文件。`);
      }
      else this.fileList = [...this.fileList, file];
      return false;
    },
    getFileList(...arg) {
      if (this.type === 'readExcel') return this.readExcel(this.fileList[0], ...arg);
      if (this.fileNum === 1) return this.fileList[0];
      return this.fileList;
    }
  },
}
</script>
<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/srm-detailMes/srm-upload.vue